import * as yup from "yup";
const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
/**
 * ChangePasswordSchema for validation
 * @type {*}
 */
export const ChangePasswordSchema = yup.object().shape({
  currentPassword: yup.string().required().label("Current password"),
  password: yup.string().required().min(8).max(16).label("Password"),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), ""], "Passwords must match")
    .label("Confirm password"),
});

/**
 * add user  validation
 * @type {*}
 */
export const AddUserSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .required()
    .min(1, "Minimum 1 characters required.")
    .max(30, "You have reached maximum limit of 30 characters.")
    .label("First Name"),

  last_name: yup
    .string()
    .trim()
    .required()
    .min(1, "Minimum 1 characters required.")
    .max(30, "You have reached maximum limit of 30 characters.")
    .label("Last Name"),
  email: yup
    .string()
    .email("Email must be a valid email.")
    .max(255, "You have reached maximum limit of 255 characters.")
    .required()
    .matches(emailRegExp, "Email must be a valid email")
    .label("Email"),
  phone: yup
    .string()
    .required("Phone number is required.")
    .test("len", "Phone number must have at least 10 digits", (val) => {
      if (val) {
        return val.toString().length >= 10;
      }
      return false;
    }),
  designation: yup
    .string()
    .trim()
    .min(1, "Minimum 1 characters required.")
    .max(30, "You have reached maximum limit of 30 characters.")
    .label("Designation"),
});

/**
 * SignatureSchema for validation
 * @type {*}
 */
export const SignatureSchema = yup.object().shape({
  sign: yup.string().required().label("Signature"),
});
